import React, { useState } from "react";
import "./style.scss";
import { Button, Menu, MenuItem } from "@mui/material";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import LogoutModal from "../SideBar/LogoutModal";
import AccessibleTooltip from "../Tooltip/Tooltip.js";

import threeBar from "../../assets/images/threeBar.svg";
import logo from "../../assets/images/logo.svg";
import downarrow from "../../assets/images/downarrow.png";
import profile from "../../assets/images/profile.svg";
import dark_mode_active from "../../assets/images/dark_mode_active.svg";
import dark_mode from "../../assets/images/dark_mode.svg";
import logoutmenu from "../../assets/images/logoutmenu.svg";
import account_circle_active from "../../assets/images/account_circle_active.svg";
import account_circle from "../../assets/images/account_circle.svg";

import {
  getDecodedTokenAndAccess,
  handleDeleteToken,
  handleSidebarToggle,
  handleSkipLinkActivate,
  handleSkipLinkKeyDown,
} from "../../utils/headerUtils.js";

const Header = ({ showRest = true, diffClass = "" }) => {
  const [profileAnchor, setProfileAnchor] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname;

  // ✅ Utils used here
  const { viewGlobalApplication } = getDecodedTokenAndAccess();

  const isProfileMenuOpen = Boolean(profileAnchor);

  const handleProfileClick = (event) => setProfileAnchor(event.currentTarget);
  const handleCloseProfileMenu = () => setProfileAnchor(null);

  const logoutWrapper = () => setOpenDeleteModal(true);

  return (
    <>
      <div className={`header_wrapper ${diffClass}`} role="banner">
        <div className="sideBarToggler">
          <button className="bars" onClick={() => handleSidebarToggle(dispatch)}>
            <img src={threeBar} alt="Toggle sidebar" />
          </button>
        </div>
        <div className="logo">
          <Link to={showRest ? "/dashboard" : "#"} aria-label="Lockdown Experts Dashboard" className="logo-class">
            <img alt="Dashboard Logo" aria-hidden="true" src={logo} />
          </Link>
        </div>
        <a
          href="#main"
          id="verifyDashboardLogo"
          className="skip"
          onClick={(e) => handleSkipLinkActivate(e, "heading-title")}
          onKeyDown={(e) => handleSkipLinkKeyDown(e, "heading-title")}
        >
          Skip to main content
        </a>
        {showRest && (
          <div className="navbar">
            <nav aria-label="top">
              <ul>
                {viewGlobalApplication && (
                  <li>
                    <AccessibleTooltip bottom title="Global Settings">
                      <Link
                        to="/globalSettings"
                        aria-label="Global Settings"
                        aria-current={
                          currentPath === "/globalSettings" ? "page" : undefined
                        }
                        className={currentPath === "/globalSettings" ? "active" : ""}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src={
                            currentPath === "/globalSettings"
                              ? dark_mode_active
                              : dark_mode
                          }
                        />
                      </Link>
                    </AccessibleTooltip>
                  </li>
                )}

                <li>
                  <div className="profileDropdownWrapper">
                    <AccessibleTooltip bottom title="Profile">
                      <Button
                        id="profile-dropdown-button"
                        aria-controls={
                          isProfileMenuOpen ? "profile-menu" : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={isProfileMenuOpen ? "true" : "false"}
                        onClick={handleProfileClick}
                        className="threeDotsBtn profile"
                        aria-label="Profile icon"
                        disableFocusRipple
                        disableRipple
                      >
                        <img
                          src={
                            isProfileMenuOpen
                              ? account_circle_active
                              : account_circle
                          }
                          alt=""
                          aria-hidden="true"
                        />
                        <span>
                          <img
                            src={downarrow}
                            alt=""
                            aria-hidden="true"
                            className={`rotateprofile ${
                              isProfileMenuOpen ? "rotatingprofile" : ""
                            }`}
                          />
                        </span>
                      </Button>
                    </AccessibleTooltip>

                    <Menu
                      id="profile-menu"
                      anchorEl={profileAnchor}
                      open={isProfileMenuOpen}
                      onClose={handleCloseProfileMenu}
                      MenuListProps={{
                        "aria-labelledby": "profile-dropdown-button",
                        role: "menu",
                      }}
                      className="profileSelectMenu mt-60"
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuItem
                        component={Link}
                        to="/profile"
                        aria-label="Profile"
                        aria-current={
                          currentPath === "/profile" ? "page" : undefined
                        }
                        onClick={handleCloseProfileMenu}
                      >
                        <img src={profile} alt="Profile" /> Profile
                      </MenuItem>

                      <div className="seprater" role="presentation" aria-hidden="true" />

                      <MenuItem
                        component="button"
                        onClick={() => {
                          handleCloseProfileMenu();
                          logoutWrapper();
                        }}
                        className="logout-button"
                        aria-label="Logout"
                      >
                        <img src={logoutmenu} alt="Logout" /> Logout
                      </MenuItem>
                    </Menu>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
      <LogoutModal
        setOpenDeleteModal={setOpenDeleteModal && showRest}
        openDeleteModal={openDeleteModal}
        handleDelete={() => handleDeleteToken(dispatch)}
      />
    </>
  );
};

export default Header;
